<template>
  <section class="content">
    <vue-headful title="QB-STATISTICS | Navigation"></vue-headful>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Menükonfiguration</h3>
        <div class="box-tools">
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="box-toolbar">
          <!--<div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-sm btn-primary" @click="updateNavTree"><i class="fa fa-save mr-5"></i>Save</button>
          </div>-->
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-default" data-toggle="tab" data-target="#createMenu" @click="selectedMenuItem.id = false"><i class="fa fa-plus mr-5"></i>Create Item</button>
            <!--<button type="button" class="btn btn-default" data-toggle="tab" data-target="#createHeader"><i class="fa fa-plus mr-5"></i>Create Header</button>-->
          </div>
          <links-box></links-box>
        </div>
        <div class="row">
          <!-- LEFT -->
          <div class="col-md-5">
            <!-- MENU CONFIG -->
            <div class="menu-scroll-container">
             <nested-draggable :tasks="navTree[0].children" :bus="bus" v-if="navTree && navTree[0] && navTree[0].children"></nested-draggable>
            </div>
          </div>
          <!-- RIGHT -->
          <div class="col-md-7">
            <div class="page-view tab-content" id="menuSettings">
              <!-- CREATE MENU-->
              <div id="createMenu" class="tab-pane active" aria-expanded="true">
                <h4 class="page-view-title"><i class="fa fa-angle-double-left mr-5"></i><template v-if="selectedMenuItem.id">{{`Create new Child Item for ${selectedMenuItem.name}`}}</template><template v-else>Create new Menu Item</template></h4>
                <div class="box box-default box-solid">
                  <div class="box-body form-horizontal">
                    <div class="form-group">
                      <label for="itemName" class="control-label col-md-3 col-sm-4">Item Name:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="itemName" placeholder="Item Name" class="form-control" v-model="newMenuItem.name"></div>
                    </div>
                    <div class="form-group" hidden>
                      <label for="itemIcon" class="control-label col-md-3 col-sm-4">
                        <a class="btn btn-xs mr-5" data-toggle="tooltip" data-original-title="Click for icon reference" href="https://fontawesome.com/v4.7.0/icons/" target="_blank"><i class="fa fa-question-circle"></i></a>Icon:
                      </label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="itemIcon" placeholder="e.g. fa-dashboard" class="form-control" v-model="newMenuItem.icon"></div>
                    </div>
                    <div class="form-group" hidden>
                      <label for="parentID" class="control-label col-md-3 col-sm-4">Parent ID:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="parentID" placeholder="Parent ID" class="form-control" v-model="newMenuItem.parent_id"></div>
                    </div>
                    <div class="form-group" hidden>
                      <label for="sequence" class="control-label col-md-3 col-sm-4">Sequence:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="sequence" placeholder="Sequence" class="form-control" v-model="newMenuItem.sequence"></div>
                    </div>
                    <hr>
                    <div class="form-group no-margin">
                      <label for="roles" class="control-label col-md-3 col-sm-4">Modules:</label>
                      <div class="col-md-9 col-sm-8">
                        <button type="button" class="btn btn-default btn-sm" data-toggle="modal" data-target="#addModuleModal" @click="selectedMenuItem = newMenuItem"><i class="fa fa-plus mr-5"></i>Add Module</button>
                        <draggable class="module-config-list ui-sortable" tag="ul" :list="newMenuItem.modules" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                          <li v-for="el in newMenuItem.modules" :key="`${el.name}-${el.id}-${el.sequence}`">
                          <div class="config-item">
                              <span class="handle ui-sortable-hanlde">
                                <i class="fa fa-arrows"></i>
                              </span>
                            <span class="text">{{el.name}}</span>
                            <div class="tools">
                              <div class="btn-group btn-group-sm">
                                <button type="button" class="btn btn-default" data-toggle="modal" data-target="#editModuleModal" title="View or edit this item"><i class="fa fa-pencil"></i></button>
                                <button type="button" class="btn btn-default" data-toggle="modal" data-target="#deleteModuleModal" title="Delete this Module"><i class="fa fa-trash text-danger"></i></button>
                              </div>
                            </div>
                          </div>
                        </li>
                        </draggable>
                      </div>
                    </div>
                  </div>
                  <div class="box-footer text-right">
                    <button class="btn btn-sm btn-primary" @click="addMenuItem">Save<i class="fa fa-save ml-5"></i></button>
                  </div>
                </div>
              </div>
             <!--  CREATE HEADER
              <div id="createHeader" class="tab-pane" aria-expanded="false">
                <h4 class="page-view-title"><i class="fa fa-angle-double-left mr-5"></i>Create Header</h4>
                <form action="#" method="post" class="box box-default box-solid">
                  <div class="box-body form-horizontal">
                    <div class="form-group">
                      <label for="newHeaderTitle" class="control-label col-md-3 col-sm-4">Header Title:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="newHeaderTitle" placeholder="Header Title" class="form-control" value=""></div>
                    </div>
                    <div class="form-group no-margin">
                      <label for="sequence" class="control-label col-md-3 col-sm-4">Sequence:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="sequence" placeholder="Sequence" class="form-control" value=""></div>
                    </div>
                  </div>
                  <div class="box-footer text-right">
                    <button type="submit" class="btn btn-sm btn-primary">Save<i class="fa fa-save ml-5"></i></button>
                  </div>
                </form>
              </div>
              &lt;!&ndash; EDIT HEADER &ndash;&gt;
              <div id="editHeader" class="tab-pane" aria-expanded="false">
                <h4 class="page-view-title"><i class="fa fa-angle-double-left mr-5"></i>Edit Header</h4>
                <form action="#" method="post" class="box box-default box-solid">
                  <div class="box-body form-horizontal">
                    <div class="form-group">
                      <label for="editHeaderTitle" class="control-label col-md-3 col-sm-4">Header Title:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="editHeaderTitle" placeholder="Header Title" class="form-control" value="Statistics"></div>
                    </div>
                    <div class="form-group no-margin">
                      <label for="sequence" class="control-label col-md-3 col-sm-4">Sequence:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="sequence" placeholder="Sequence" class="form-control" value="3"></div>
                    </div>
                  </div>
                  <div class="box-footer text-right">
                    <button type="submit" class="btn btn-sm btn-primary">Save<i class="fa fa-save ml-5"></i></button>
                  </div>
                </form>
              </div>-->
              <div id="editMenuItem" class="tab-pane" aria-expanded="false">
                <h4 class="page-view-title"><i class="fa fa-angle-double-left mr-5"></i>Edit Item "{{selectedMenuItem.name}}"</h4>
                <div class="box box-default box-solid">
                  <div class="box-body form-horizontal">
                    <div v-if="errors" class="alert alert-danger alert-dismissible">
                      <button type="button" class="close" data-dismiss="alert" aria-hidden="true" @click="errors = false">×</button>
                      <h4><i class="icon fa fa-warning mr-5"></i>Achtung!</h4>
                      Es gibt folgende Fehler:
                      <ul>
                        <li v-for="err in Object.keys(errors)">
                          {{err}}: {{typeof errors[err] === 'string' ? errors[err] : errors[err][0] }}
                        </li>
                      </ul>
                    </div>
                    <div class="form-group">
                      <label for="editItemName" class="control-label col-md-3 col-sm-4">Item Name:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="editItemName" placeholder="Item Name" class="form-control" v-model="selectedMenuItem.name"></div>
                    </div>
                    <!--<div class="form-group" hidden>
                      <label for="editItemIcon" class="control-label col-md-3 col-sm-4">
                        <a class="btn btn-xs mr-5" data-toggle="tooltip" data-original-title="Click for icon reference" href="https://fontawesome.com/v4.7.0/icons/" target="_blank"><i class="fa fa-question-circle"></i></a>Icon:
                      </label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="editItemIcon" placeholder="e.g. fa-dashboard" class="form-control" value="fa-dashboard"></div>
                    </div>-->
                    <div class="form-group">
                      <label for="rootID" class="control-label col-md-3 col-sm-4">ID:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="rootID" placeholder="Parent ID" class="form-control" v-model="selectedMenuItem.id" disabled></div>
                    </div>
                    <!--<div class="form-group" hidden>
                      <label for="parentID" class="control-label col-md-3 col-sm-4">Parent ID:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="parentID" placeholder="Parent ID" class="form-control" value="0"></div>
                    </div>
                    <div class="form-group" hidden>
                      <label for="sequence" class="control-label col-md-3 col-sm-4">Sequence:</label>
                      <div class="col-md-9 col-sm-8"><input type="text" id="sequence" placeholder="Sequence" class="form-control" v-model="selectedMenuItem.sequence"></div>
                    </div>-->
                    <hr>
                    <div class="form-group no-margin">
                      <label for="modules" class="control-label col-md-3 col-sm-4">Modules:</label>
                      <div class="col-md-9 col-sm-8">
                        <button type="button" class="btn btn-default btn-sm" data-toggle="modal" data-target="#addModuleModal"><i class="fa fa-plus mr-5"></i>Add Module</button>
                        <draggable class="module-config-list ui-sortable" tag="ul" :list="selectedMenuItem.modules">
                          <li v-for="el in selectedMenuItem.modules" :key="`${el.name}-${el.id}-${el.sequence}`">
                            <div class="config-item">
                              <span class="handle ui-sortable-hanlde">
                                <i class="fa fa-arrows"></i>
                              </span>
                              <span class="text">{{el.name}}</span>
                              <div class="tools">
                                <div class="btn-group btn-group-sm">
                                  <button type="button" class="btn btn-default" data-toggle="modal" data-target="#editModuleModal" title="View or edit this item" @click="selectedModule = el"><i class="fa fa-pencil"></i></button>
                                  <button type="button" class="btn btn-default" data-toggle="modal" data-target="#deleteModuleModal" title="Delete this Module" @click="selectedModule = el"><i class="fa fa-trash text-danger"></i></button>
                                </div>
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </div>
                    </div>
                  </div>
                  <div class="box-footer text-right">
                    <button class="btn btn-sm btn-primary" @click="updateMenuItem">Save<i class="fa fa-save ml-5"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="addModuleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Add new Module</h4>
          </div>
          <div class="modal-body">
            <div v-if="errors" class="alert alert-danger alert-dismissible">
              <button type="button" class="close" data-dismiss="alert" aria-hidden="true" @click="errors = false">×</button>
              <h4><i class="icon fa fa-warning mr-5"></i>Achtung!</h4>
              Es gibt folgende Fehler:
              <ul>
                <li v-for="err in Object.keys(errors)">
                  {{err}}: {{typeof errors[err] === 'string' ? errors[err] : errors[err][0] }}
                </li>
              </ul>
            </div>
            <div class="form-horizontal">
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-4">Module:</label>
                <div class="col-md-9 col-sm-8">
                  <select class="form-control" v-model="moduleForItem.id">
                    <option v-for="m in modules" :value="m.id">{{m.value}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="endpoint" class="control-label col-md-3 col-sm-4">Endpoint:</label>
                <div class="col-md-9 col-sm-8"><input type="text" id="endpoint" placeholder="https://endpoint.tld/path" class="form-control" v-model="moduleForItem.endpoint"></div>
              </div>
              <div class="form-group">
                <label for="configString" class="control-label col-md-3 col-sm-4">Config:</label>
                <div class="col-md-9 col-sm-8"><textarea rows="9" id="configString" placeholder="Config String" class="form-control" v-model="moduleForItem.config"></textarea></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeAddModule"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-primary" @click="addModuleToItem">Add<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editModuleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Module Bearbeiten</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-4">Module:</label>
                <div class="col-md-9 col-sm-8">
                  <select class="form-control" v-model="selectedModule.id">
                    <option selected>Select Module</option>
                    <option v-for="m in modules" :value="m.id">{{m.value}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="editEndpoint" class="control-label col-md-3 col-sm-4">Endpoint:</label>
                <div class="col-md-9 col-sm-8"><input type="text" id="editEndpoint" placeholder="https://endpoint.tld/path" class="form-control" value="https://endpoint.tld/path" v-model="selectedModule.endpoint"></div>
              </div>
              <div class="form-group">
                <label for="editConfigString" class="control-label col-md-3 col-sm-4">Config:</label>
                <div class="col-md-9 col-sm-8"><textarea rows="9" id="editConfigString" placeholder="Config String" class="form-control" v-model="selectedModule.config"></textarea></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeEditModule"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="updateMenuItem">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-danger fade" id="deleteMenuModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Delete Menu Item</h4>
          </div>
          <div class="modal-body text-center">
            <h3>
              Are you sure you want to delete Menu Item <br>"{{selectedMenuItem.name}}"?
            </h3>
            <p class="text-bold text-danger"><i class="fa fa-warning mr-5"></i>This change is irreversible!</p>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeDeleteMenuItem"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-danger" @click="deleteMenuItem">Delete<i class="fa fa-trash ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-danger fade" id="deleteModuleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Delete Module</h4>
          </div>
          <div class="modal-body text-center">
            <h3>
              Are you sure you want to delete the Module "{{selectedModule.name}}"?
            </h3>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeDeleteModule"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-danger" @click="deleteModule">Delete<i class="fa fa-trash ml-5"></i></button>
          </div>
        </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
  import axios from 'axios'
  import nestedDraggable from '@/components/Nested'
  import draggable from 'vuedraggable'
  import Api from '@/services/Api'
  import Vue from 'vue'
  import TestShell from './TestShell'
  export default {
    name: 'NavigationManagement',
    data () {
      return {
        bus: new Vue(),
        navTree: [],
        routes: [],
        errors: false,
        newMenuItem: {
          name: '',
          children: [],
          sequence: '',
          modules: [],
          parent_id: 1
        },
        modules: [],
        moduleForItem: {
          endpoint: '/statistics/',
          config: '{}',
          sequence: ''
        },
        selectedModule: {},
        selectedMenuItem: {
          name: '',
          children: [],
          sequence: '',
          modules: [],
          id: false
        },
        isDragging: false
      }
    },
    components: {
      nestedDraggable,
      draggable
    },
    created() {
      this.bus.$on('select', (who) => {
        Api().get(`/frontend/navigation/page?id=${who.id}`)
        .then(res => {
          this.selectedMenuItem = res.data
        }).catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      })
      this.bus.$on('updateTree', (who) => {
        Api().get(`/frontend/navigation/page?id=${who.id}`)
          .then(res => {
            res.data.sequence = who.sequence
            Api().put(`/frontend/navigation/page`, res.data)
              .then(res => {
                this.$notify({
                  group: 'foo',
                  type: 'success',
                  title: 'Success!',
                  text: 'Navigation Tree Updated Successfully'
                });
                this.$store.commit('updateNavTree', this.navTree)
                console.log('200 OK')
              }).catch(error => {
                this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: 'Error',
                  text: 'Es gab ein Fehler'
                });
            })
          }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
        })
      })
    },
    methods: {
      onSelect (val) {
        this.selectedMenuItem = val
      },
      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        );
      },
      updateNavTree () {
        this.navTree.forEach((m, index) => {
          m.sequence = index + 1
        })
        Api().put(`/frontend/navigation/page`, this.navTree)
        .then(res => {
          Api().get('/frontend/navigation/page/tree')
            .then(response => {
              this.navTree = response.data
              this.$store.commit('updateNavTree', this.navTree)
              console.log('200 OK')
            })
        })
      },
      addMenuItem () {
        this.newMenuItem.modules.forEach((m, index) => {
          m.sequence = index + 1
        })
        this.newMenuItem.parent_id = this.selectedMenuItem.id || this.newMenuItem.parent_id
        Api().post('/frontend/navigation/page', this.newMenuItem)
        .then(res => {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Success!',
            text: 'New Item Created Successfully'
          });
          Api().get('/frontend/navigation/page/tree')
            .then(response => {
              this.navTree = response.data
              this.$store.commit('updateNavTree', this.navTree)
              console.log('200 OK')
            }).catch(error => {
              this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: 'Es gab ein Fehler'
              });
          })
        }).catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      updateMenuItem () {
        Api().put('/frontend/navigation/page', this.selectedMenuItem)
        .then(res => {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Success!',
            text: 'Item Updated Successfully'
          });
          Api().get('/frontend/navigation/page/tree')
          .then(response => {
            this.navTree = response.data
            this.$store.commit('updateNavTree', this.navTree)
            console.log('200 OK')
          }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
          })
        }).catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      addModuleToItem () {
        let mod = this.modules.find(m => {return m.id === this.moduleForItem.id})
        this.moduleForItem.name = mod.value
        this.moduleForItem.sequence = this.selectedMenuItem.modules.length + 1
        this.selectedMenuItem.modules.push(this.moduleForItem)
        if (!('id' in this.selectedMenuItem)) {
          this.newMenuItem.modules = this.selectedMenuItem.modules
          this.newMenuItem.parent_id = this.selectedMenuItem.id || this.newMenuItem.parent_id
          this.moduleForItem = {
            config: '{}',
            endpoint: '/statistics/'
          }
          this.$refs.closeAddModule.click()
        } else {
          Api().put('/frontend/navigation/page', this.selectedMenuItem)
            .then(res => {
              this.$notify({
                group: 'foo',
                type: 'success',
                title: 'Success!',
                text: 'Module Successfully added to Menu Item'
              });
              Api().get('/frontend/navigation/page/tree')
                .then(response => {
                  this.navTree = response.data
                  this.$store.commit('updateNavTree', this.navTree)
                  this.moduleForItem = {
                    config: '{}',
                    endpoint: '/statistics/'
                  }
                  this.$refs.closeAddModule.click()
                }).catch(error => {
                  this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Es gab ein Fehler'
                  });
              })
            }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
          })
        }

      },
      deleteMenuItem () {
        Api().delete(`/frontend/navigation/page?id=${this.selectedMenuItem.id}`)
          .then(res => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success!',
              text: 'Menu Item deleted Successfully'
            });
            Api().get('/frontend/navigation/page/tree')
              .then(response => {
                this.navTree = response.data
                this.$store.commit('updateNavTree', this.navTree)
                this.$refs.closeDeleteMenuItem.click()
              }).catch(error => {
              this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: 'Es gab ein Fehler'
              });
            })
          }).catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      deleteModule () {
        this.selectedMenuItem.modules = this.selectedMenuItem.modules.filter(m => {return m.id !== this.selectedModule.id })
        this.updateMenuItem()
        this.$refs.closeDeleteModule.click()
      },
      recursiveRouteCreator (nav, target) {
        nav.forEach(n => {
          if (n.children.length > 0) {
            this.recursiveRouteCreator(n.children, target)
          } else {
            let routeData = {
              path: `/${n.name.toLowerCase().split(' ').join('-')}`,
              name: n.name.toLowerCase().split(' ').join('-'),
              component: TestShell
            }
            target.push(routeData)
          }
        })
      }
    },
    mounted () {
      axios.all([Api().get('/frontend/navigation/page/tree'), Api().get('/frontend/navigation/module/list')])
      .then(axios.spread((...responses) => {
        this.navTree = responses[0].data
        this.$store.commit('updateNavTree', this.navTree)
        this.modules = responses[1].data
      })).catch(error => {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: 'Es gab ein Fehler'
        });
      })
    }
  }
</script>
<style>

</style>
